import type { Table } from '../../types/@types/table';
import { Button } from '../ui';

interface TableCardProps {
  table: Table & { name?: string };
  onSelect: (table: Table) => void;
  onUnjoin?: (id: string) => void;
  isUnjoining?: boolean;
}

const STATUS_LABELS: Record<Table['status'], string> = {
  Disponible: 'Disponible',
  Ocupada: 'Ocupada',
  Reservada: 'Reservada',
};

const STATUS_STYLES: Record<Table['status'], string> = {
  Disponible: 'bg-success text-white',
  Ocupada: 'bg-danger text-white',
  Reservada: 'bg-primary text-primary-fg',
};

export function TableCard({
  table,
  onSelect,
  onUnjoin,
  isUnjoining,
}: TableCardProps) {
  const isJoined = !!table.parent_id;

  return (
    <article className="flex h-full flex-col justify-between gap-4 rounded-2xl border border-divider bg-surface p-4 shadow-card transition-shadow hover:shadow-card/80 focus-within:outline-none focus-within:ring-2 focus-within:ring-primary/70 focus-within:ring-offset-2 focus-within:ring-offset-surface">
      <div className="space-y-3">
        <header className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="font-semibold leading-tight text-[clamp(18px,2.4vw,22px)] text-text">
              {table.name ?? `Mesa ${table.number}`}
            </p>
            <p className="text-sm font-medium text-text-muted">
              Mesa #{table.number}
            </p>
            {isJoined && (
              <p className="text-[10px] font-bold uppercase tracking-wider text-primary">
                Unida a Mesa #{table.parent_id}
              </p>
            )}
            <p className="text-xs text-text-muted">ID: {table.id}</p>
          </div>
          <span
            className={`inline-flex min-h-[28px] items-center rounded-full px-3 text-xs font-semibold uppercase tracking-wide ${
              STATUS_STYLES[table.status]
            }`}
            aria-label={`Mesa ${table.number} ${STATUS_LABELS[table.status]}`}
          >
            {STATUS_LABELS[table.status]}
          </span>
        </header>
      </div>
      <div className="flex flex-col gap-2">
        <Button
          type="button"
          onClick={() => onSelect(table)}
          className="min-h-[44px] w-full rounded-full text-[length:clamp(15px,2.4vw,17px)]"
          aria-label={`Seleccionar mesa ${table.number}`}
        >
          Seleccionar mesa
        </Button>
        {isJoined && onUnjoin && (
          <Button
            type="button"
            variant="outline"
            isLoading={isUnjoining}
            onClick={(e) => {
              e.stopPropagation();
              onUnjoin(table.id);
            }}
            className="min-h-[44px] w-full rounded-full text-xs"
          >
            Separar Mesa
          </Button>
        )}
      </div>
    </article>
  );
}

export default TableCard;
